import { useState } from "react";
import axios from "axios";
import { toast, Toaster } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Footer() {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSending(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("You're on the list. Watch your inbox for the first dispatch.");
      setEmail("");
    } catch {
      toast.error("Could not subscribe. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <footer id="contact" className="paper-bg border-t hairline pt-24 md:pt-32 pb-10 relative" data-testid="footer">
      <Toaster position="bottom-center" richColors />
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        {/* Contact + Newsletter row */}
        <div className="grid grid-cols-12 gap-6 mb-24 md:mb-32">
          <div className="col-span-12 md:col-span-5">
            <span className="font-mono-editorial text-[11px] text-[color:var(--muted)]">— Stay in the room</span>
            <h3 className="mt-6 font-display text-4xl md:text-5xl leading-[1] tracking-tight">
              A quiet dispatch,<br />
              once a fortnight.
            </h3>
            <p className="mt-6 text-[color:var(--muted)] max-w-[42ch] leading-relaxed">
              A short letter on what we&rsquo;re reading, what the cohorts are teaching us, and how the SPI-PSY
              model is evolving. No noise. Unsubscribe in one click.
            </p>
          </div>

          <form
            onSubmit={subscribe}
            className="col-span-12 md:col-span-6 md:col-start-7 self-end"
            data-testid="newsletter-form"
          >
            <div className="flex items-center border-b hairline border-b-[1px] pb-2">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="parent@family.com"
                className="flex-1 bg-transparent outline-none py-4 text-lg placeholder:text-[color:var(--muted)]/60"
                data-testid="newsletter-email-input"
              />
              <button
                type="submit"
                disabled={sending}
                className="h-11 px-5 rounded-full bg-[color:var(--ink)] text-[color:var(--inv)] hover:bg-[color:var(--brand)] transition-colors duration-500 disabled:opacity-40 text-sm"
                data-testid="newsletter-submit-btn"
              >
                {sending ? "…" : "Subscribe"} <span className="ml-2">→</span>
              </button>
            </div>
            <p className="mt-3 text-xs text-[color:var(--muted)]">
              hello@shemusi.in · +91 · Bengaluru, India
            </p>
          </form>
        </div>

        {/* Sitemap */}
        <div className="grid grid-cols-12 gap-6 py-10 border-t hairline text-sm">
          <div className="col-span-6 md:col-span-3">
            <span className="font-mono-editorial text-[10px] text-[color:var(--muted)]">Studio</span>
            <ul className="mt-4 space-y-2 text-[color:var(--ink)]/80">
              <li><a href="#batches" className="link-underline">Three Batches</a></li>
              <li><a href="#founders" className="link-underline">Founders</a></li>
              <li><a href="#model" className="link-underline">SPI-PSY Model</a></li>
              <li><a href="#schedule" className="link-underline">Schedule</a></li>
              <li><a href="#assessment" className="link-underline">Assessment</a></li>
              <li><a href="#fees" className="link-underline">Fees</a></li>
            </ul>
          </div>
          <div className="col-span-6 md:col-span-3">
            <span className="font-mono-editorial text-[10px] text-[color:var(--muted)]">Parents</span>
            <ul className="mt-4 space-y-2 text-[color:var(--ink)]/80">
              <li><a href="#enroll" className="link-underline">Enrollment</a></li>
              <li><a href="#contact" className="link-underline">Contact</a></li>
            </ul>
          </div>
          <div className="col-span-6 md:col-span-3">
            <span className="font-mono-editorial text-[10px] text-[color:var(--muted)]">Follow</span>
            <ul className="mt-4 space-y-2 text-[color:var(--ink)]/80">
              <li><a href="#" className="link-underline">Instagram</a></li>
              <li><a href="#" className="link-underline">Substack</a></li>
              <li><a href="#" className="link-underline">YouTube</a></li>
            </ul>
          </div>
          <div className="col-span-6 md:col-span-3">
            <span className="font-mono-editorial text-[10px] text-[color:var(--muted)]">Legal</span>
            <ul className="mt-4 space-y-2 text-[color:var(--ink)]/80">
              <li><a href="#" className="link-underline">Privacy</a></li>
              <li><a href="#" className="link-underline">Terms</a></li>
              <li><a href="#" className="link-underline">Safeguarding</a></li>
            </ul>
          </div>
        </div>

        {/* Massive brand mark */}
        <div className="pt-10 md:pt-16" data-testid="footer-mark">
          <div className="font-display leading-[0.82] tracking-[-0.04em] text-[22vw] md:text-[17.5vw] text-[color:var(--ink)]">
            shemushi<span style={{ color: "var(--brand)" }}>.</span>
          </div>
          <div className="mt-6 flex flex-wrap items-baseline justify-between gap-4 font-mono-editorial text-[10px] text-[color:var(--muted)]">
            <span>© 2026 shemushi · inner compass program</span>
            <span>शेमुषी · every child has one · we help them find it</span>
            <span>Dr. Santosh More · Dr. Navita More</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
